import InputValidationStateBo from "../../../../../form/input/InputValidationStateBo";
import InputValidator from "../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../form/input/InputValidatorI";



export class HundeNameValidator implements InputValidatorI {
    static MAX_LENGTH = 30;

    private value?: string;

    constructor(newValue?: string) {
        this.value = newValue;
    }

    validate(): InputValidationStateBo {
        if (InputValidator.isBlank(this.value)) {
            return InputValidationStateBo.createInValid("Bitte geben Sie einen Hundenamen an.");
        }

        return InputValidationStateBo.createValid();
    }

}


